import type { ReactNode } from 'react';

import Modal from '@/components/molecules/Modal/Modal';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { AssistantPanel } from './AssistantPanel';
import { useInvoiceAssistant } from './useInvoiceAssistant';

/**
 * Acomoda el flujo y el asistente lado a lado.
 *
 * Desde 1024px el panel se acopla a la derecha y EMPUJA el flujo en vez de
 * taparlo: la gracia es ver cómo se llena el borrador mientras platicas. Más
 * angosto no caben el wizard de dos columnas y el panel, así que se abre como
 * `Modal` (hoja de alto completo en móvil).
 *
 * El árbol es el mismo abierto o cerrado, con o sin bandera: cambiar de
 * envoltura remontaría la pantalla y perdería lo que el usuario capturaba.
 *
 * Sin panel acoplado, las dos envolturas no generan caja (`contents`) y el
 * scroll es el del layout principal. Con `h-full` la página se desbordaba de
 * una caja del alto de la pantalla, y el relleno que el layout reserva para la
 * barra inferior del móvil quedaba antes del final: lo último quedaba debajo.
 */
export const InvoiceAssistantShell = ({ children }: { children: ReactNode }) => {
  const assistant = useInvoiceAssistant();
  const isWide = useMediaQuery('(min-width: 1024px)');
  const isOpen = assistant?.isOpen ?? false;
  const docked = isOpen && isWide;

  return (
    <div className={docked ? 'flex h-full' : 'contents'}>
      <div className={docked ? 'h-full min-w-0 flex-1 overflow-y-auto' : 'contents'}>{children}</div>
      {docked && (
        <aside
          aria-label='Asistente de facturación'
          className='border-h-neutral-90 h-full w-[400px] flex-none border-l'>
          <AssistantPanel docked />
        </aside>
      )}
      {isOpen && !isWide && (
        <Modal open onClose={assistant?.close} fullScreenOnMobile sx='!p-0 !max-w-[440px]'>
          <div className='flex h-full min-h-0 flex-1 flex-col md:h-[min(680px,calc(100dvh-2rem))]'>
            <AssistantPanel docked={false} />
          </div>
        </Modal>
      )}
    </div>
  );
};
